import React, {Component} from 'react'
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";
import {hasUserRight, showAxiosError} from "../../../helper/helper";
import Select from"../../../local_node_modules/react-select"
import {Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";
import Alert from 'react-s-alert';
import NavBarKS from "../../../components/NavBarKS";
import emailMask from "text-mask-addons/dist/emailMask";
import MaskedInput from "react-text-mask";
import {UserRightsEnum} from "../../../helper/enums";
import {VirtualHost} from "../../../constants";
import SweetAlert from "react-bootstrap-sweetalert";

class InboxWarning extends Component {

	constructor(props) {
		super(props);

		this.state = {
			error: {},
			inboxWarnings: [],
			selectedCustomer: null,
			loading: false,
			total: 0,
			page: 0,
			size: 10,
			manual: false,
			destinationId: null,
			sourceId: '',
			warningType: 1,
			informedAddress: '',
			checkedForAll: true,
			editWarningModal: false
		};

		this.fetchData = this.fetchData.bind(this);
		this.onChangeSourceId = this.onChangeSourceId.bind(this);
		this.persistNewWarning = this.persistNewWarning.bind(this);
		this.addWarningInfo = this.addWarningInfo.bind(this);
		this.onChangeCheckBox = this.onChangeCheckBox.bind(this);
		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.openEditWarningModal = this.openEditWarningModal.bind(this);
		this.closeEditWarningModal = this.closeEditWarningModal.bind(this);
		this.updateWarning = this.updateWarning.bind(this);
		this.itemsDelete = this.itemsDelete.bind(this);
		this.cancelDelete = this.cancelDelete.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		this.setState({
			selectedCustomer: this.props.selectedCustomer,
			warningType: 1
		});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;

		let result = validateField(rule, boundary, value);
		let error = this.state.error;

		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	onChangeCheckBox() {
		let checkedForAll = !this.state.checkedForAll;
		this.setState({
			checkedForAll
		})
	}

	onChangeSourceId(e) {
		this.setState({
			sourceId: e.target.value
		})
	}

	onChangeWarningType(e) {
		this.setState({
			warningType: e.value
		})
	}

	onChangeInformedAddress(e) {
		if(e.target.name === "informedAddress") e.target.value = e.target.value.replaceAll(/[ÜĞŞİÇÖğıüşöç]/g, "");
		this.setState({
			informedAddress: e.target.value
		})
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=createdAt,desc';
		let params = {
			url: '/customer/fetchInboxWarnings?page=' + page + '&size=' + size + sortStr,
			method: "post",
			data: self.props.selectedCustomer.vknTckn
		};
		self.setState({loading: true, manual: self.manual === true ? false : self.manual});
		request(params)
			.then(function (response) {
				if (response.data.content.length > 0) {

					let inboxWarnings = response.data.content;
					inboxWarnings.map(warning => {
						if (warning.sourceId === "0") {
							warning.sourceId = "Tüm Müşteriler İçin"
						}
						if (warning.warningType === 1) {
							warning.warningType = "e-Posta"
						} else {
							warning.warningType = "Telefon"
						}
					});

					self.setState({
						page: page,
						size: size,
						total: response.data.totalElements,
						inboxWarnings,
						loading: false,
					});
				} else {
					self.setState({
						page: page,
						size: size,
						total: response.data.totalElements,
						inboxWarnings: [],
						loading: false
					});
				}
			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	addWarningInfo() {
		let validity = this.validateComponent();
		if (validity.valid) {
			let newWarning = {};
			if (this.state.checkedForAll) {
				newWarning.sourceId = 0;
			} else {
				newWarning.sourceId = this.state.sourceId;
			}
			newWarning.warningType = this.state.warningType;
			newWarning.informedAddress = this.state.informedAddress;
			newWarning.destinationId = this.state.selectedCustomer.vknTckn;

			this.persistNewWarning(newWarning);
		} else {
			Alert.error('Hatalı alanlar var !', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	persistNewWarning(data) {
		let self = this;
		let page = this.state.page;
		let size = this.state.size;
		let params = {
			url: '/customer/saveNewInboxWarning',
			method: "post",
			data: data
		};
		request(params)
			.then(function (response) {
				self.setState({
					manual: true,
					destinationId: null,
					sourceId: '',
					warningType: 1,
					informedAddress: '',
					checkedForAll: true
				}, () => self.fetchData(undefined, undefined, page, size));
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	closeEditWarningModal() {
		this.setState({
			editWarningModal: false,
			informedAddress: ''
		})
	}

	openEditWarningModal(row) {
		let informedAddress = row.informedAddress;

		let warningType = null;
		if (row.warningType === "e-Posta") {
			warningType = 1
		} else {
			warningType = 2
		}

		this.setState({
			editWarningModal: true,
			selectedRow: row,
			warningType,
			informedAddress,
			createdAt:row.createdAt
		})
	}

	handleDelete() {

		let self = this;
		let row = this.state.item;
		let page = this.state.page;
		let size = this.state.size;

		let formData = new FormData();
		formData.append("recordId", row.recordId.toString());

		let params = {
			url: `/customer/deleteInboxWarning`,
			method: "post",
			data: formData,
		};

		self.setState({deleteBtnDisabled: true});
		request(params)
			.then(function (response) {
				self.setState({loading: false, showMessage: false, deleteBtnDisabled: false},() => self.fetchData(undefined, undefined, page, size));
				Alert.success("Silme işlemi başarıyla gerçekleştirildi.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});

			}).catch(function (error) {
			self.setState({loading: false, showMessage: false, deleteBtnDisabled: false});
			showAxiosError(error);
		});

	}

	itemsDelete(row) {
		this.setState({showMessage: true , item:row});
	}

	cancelDelete() {
		this.setState({showMessage: false});
	}

	updateWarning() {
		let validity = this.validateComponent();
		let selectedRow = this.state.selectedRow;

		let updatedWarning = {};
		updatedWarning.warningType = this.state.warningType;
		updatedWarning.informedAddress = this.state.informedAddress;
		updatedWarning.createdAt = this.state.createdAt;

		if (selectedRow.sourceId === 'Tüm Müşteriler İçin') {
			updatedWarning.sourceId = 0;
		} else {
			updatedWarning.sourceId = selectedRow.sourceId;
		}

		updatedWarning.recordId = selectedRow.recordId;
		updatedWarning.destinationId = selectedRow.destinationId;

		if(validity.valid) {
			this.closeEditWarningModal();
			this.persistNewWarning(updatedWarning);
		}else {
			Alert.error('Hatalı alanlar var !', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		}
	}

	render() {
		const source = VirtualHost.conf.resourcePrefix;

		const warningTypes = [
			{value: 1, label: "e-Posta"}
		];
		const {inboxWarnings} = this.state;
		const columns = [
			{
				Header: "Gönderici Vkn",
				accessor: "sourceId"
			},
			{
				Header: "Uyarı Türü",
				accessor: "warningType",
			},
			{
				Header: "Belirtilen e-Posta/Telefon",
				accessor: "informedAddress"
			},
			{
				Header: "",
				Cell: row => (
					<div>
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Düzenle"
								style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
								rel="tooltip"
								disabled={!hasUserRight(UserRightsEnum.settings.inboxWarning.update, this.props.currentUser)}
								className="Btn btn-sm btn-icon" onClick={() => this.openEditWarningModal(row)}>
							<i className="BtnIcon far fa-edit "/>
						</button>
						<button type="button"
								onClick={() => this.itemsDelete(row)}
								data-toggle="tooltip" data-placement="bottom" title="Sil"
								style={{background: 'linear-gradient(rgb(236 92 92 / 57%), rgb(255 66 66))'}}
								rel="tooltip" className="Btn  btn-icon">
							<i className="BtnIcon far fa-trash-alt"/>
						</button>
					</div>
				)
			}
		];
		return (

			<div className={this.props.side && 'row baseBackground'}
				 style={{boxShadow: '0 0 0 0 #ffffff', background: '#ffffff'}}>

				{this.props.side &&
				<NavBarKS/>}

				{this.state.showMessage &&
				<SweetAlert
					showCancel warning
					confirmBtnText="Evet"
					cancelBtnText="Hayır"
					confirmBtnBsStyle="danger"
					cancelBtnBsStyle="default"
					title="Bu İşlemi Yapmak İstediğinize Emin Misiniz?"
					onConfirm={this.handleDelete}
					onCancel={this.cancelDelete}
				>
					{"Fatura Uyarı Bilgileri ile ilgili olan belgeler silinecektir."}
				</SweetAlert>
				}

				{this.props.side &&
				<div className="col-sm-12" style={{marginTop: "65px"}}>
					<div className="col-sm-6">
						<h4 className="card-title">Gelen Fatura Uyarı Bilgileri</h4>
					</div>
				</div>}
				<div className="col-sm-12">
					<div className={this.props.side ? "FormRenk col-sm-12" : "FormRenk"}>
						<div className="col-sm-12">
							<div className="row" style={{marginBottom: '20px'}}>
								<div className="col-sm-2">
									<label className="col-form-label">Tüm Müşteriler İçin :</label>
								</div>
								<div className="col-sm-4">
									<Label check>
										<Input type="checkbox" checked={this.state.checkedForAll}
											   onChange={this.onChangeCheckBox}/>
									</Label>
								</div>
							</div>

							{!this.state.checkedForAll &&
							<div className="row">
								<div className="col-sm-2">
									<label className="col-form-label">Gönderici VKN :</label>
								</div>
								<div className="col-sm-4">
									<div className={"form-group" + this.validateClass('tSourceId')}>
										<input className="form-control"
											   type="text"
											   name="sourceId"
											   maxLength={11}
											   id="tSourceId"
											   data-vlength="10,11"
											   onBlur={this.validateField}
											   ref="tSourceId"
											   value={this.state.sourceId}
											   onChange={(e) => this.onChangeSourceId(e)}/>
										{this.validateMessage('tSourceId') !== "" &&
										<UncontrolledTooltip placement="right" target="tSourceId" delay={0}>
											{this.validateMessage("tSourceId")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>}

							{this.state.checkedForAll &&
							<div className="row">
								<div className="col-sm-2">
									<label className="col-form-label">Gönderici VKN :</label>
								</div>
								<div className="col-sm-4">
									<div className="form-group">
										<input className="form-control"
											   disabled={this.state.checkedForAll}
											   type="text"
											   name="sourceId"
											   maxLength={11}
											   id="tSourceId"
											   value={this.state.sourceId}
											   onChange={(e) => this.onChangeSourceId(e)}/>
									</div>
								</div>
							</div>}
						</div>

						<hr style={{marginRight: '60px'}}></hr>

						<div className="row" style={{margin:"unset",marginTop:"10px"}}>
								<div className="col-sm-2">
									<label className="col-form-label">Uyarı Türü :</label>
								</div>
								<div className="col-sm-4">
									<div className={"form-group" + this.validateClass('tCity')}
										 style={{padding: '0px'}}>
										<Select
											clearable={false}
											className="select-control"
											name="warningType"
											id="tWarningType"
											ref="tWarningType"
											value={this.state.warningType}
											placeholder="Seçiniz..."
											onChange={(e) => this.onChangeWarningType(e)}
											options={warningTypes}
										/>
									</div>
								</div>

							<div className="col-sm-4">
								{this.state.warningType === 1 &&

									<div className={"form-group" + this.validateClass('tInformedAddress')}>
										<MaskedInput className="form-control"
													 mask={emailMask}
													 placeholder="_________@______.___"
													 type="text"
													 name="informedAddress"
													 inputProps={{vdata: "email", vlength: '1,255'}}
													 id="tInformedAddress"
													 ref="tInformedAddress"
													 onBlur={() => this.validateField({
														 target: {
															 id: "tInformedAddress",
															 dataset: {vdata: "email", vlength: '1,255'},
															 value: this.state.informedAddress
														 }
													 })}
													 value={this.state.informedAddress}
													 onChange={(e) => this.onChangeInformedAddress(e)}/>
										{this.validateMessage('tInformedAddress') !== "" &&
										<UncontrolledTooltip placement="right" target="tInformedAddress" delay={0}>
											{this.validateMessage("tInformedAddress")}
										</UncontrolledTooltip>}
									</div>
								}

								{this.state.warningType === 2 &&
								<div className="col-sm-12">
									<div className={"form-group" + this.validateClass('tInformedAddress')}>
										<MaskedInput className="form-control"
													 mask={['0', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
													 placeholder="0(___) ___-____"
													 type="text"
													 name="informedAddress"
													 id="tInformedAddress"
													 ref="tInformedAddress"
													 inputProps={{vdata: "required", vlength: '1,255'}}
													 onBlur={() => this.validateField({
														 target: {
															 id: "tInformedAddress",
															 dataset: {vdata: 'required', vlength: '1,255'},
															 value: this.state.informedAddress
														 }
													 })}
													 value={this.state.informedAddress}
													 onChange={(e) => this.onChangeInformedAddress(e)}/>
										{this.validateMessage('tInformedAddress') !== "" &&
										<UncontrolledTooltip placement="right" target="tInformedAddress" delay={0}>
											{this.validateMessage("tInformedAddress")}
										</UncontrolledTooltip>}
									</div>
								</div>}
							</div>
						</div>

						<div className="col-sm-12 row">
							<div className="col-sm-10 row"></div>
							<div className="col-sm-2 row">
								<Button type="button"
										data-toggle="tooltip" data-placement="bottom"
										title="Ekle"
										style={{
											background: 'linear-gradient(rgba(159, 208, 55, 0.6), rgb(159, 208, 55))'
										}}
										disabled={!hasUserRight(UserRightsEnum.settings.inboxWarning.create, this.props.currentUser)}
										rel="tooltip" className="col-sm TekBtn ekle"
										onClick={this.addWarningInfo}> Ekle
								</Button>
							</div>
						</div>
					</div>
				</div>
				<div className="col-sm-12 row" style={{right: '-15px'}}>
					<Table columns={columns}
						   content={inboxWarnings}
						   total={this.state.total}
						   page={this.state.page}
						   size={this.state.size}
						   manual={this.state.manual}
						   options={["5", "10", "20", "50", "100"]}
						   fetchData={this.fetchData}
					/>
				</div>

				<Modal isOpen={this.state.editWarningModal}>
					<ModalHeader toggle={this.closeEditWarningModal}>Uyarı Bilgisi Düzenle</ModalHeader>
					<ModalBody>
						<div className="row">
								<div className="col-sm-2" style={{paddingRight:0}}>
									<label className="col-form-label">Uyarı Türü :</label>
								</div>
								<div className="col-sm-5">
									<div className={"form-group" + this.validateClass('tCity')}>
										<Select
											clearable={false}
											className="select-control"
											name="warningType"
											id="tWarningType"
											ref="tWarningType"
											value={this.state.warningType}
											placeholder="Seçiniz..."
											onChange={(e) => this.onChangeWarningType(e)}
											options={warningTypes}
										/>
									</div>
								</div>


							<div className="col-sm-5">
								{this.state.warningType === 1 &&
									<div className={"form-group" + this.validateClass('tInformedAddress')}>
										<MaskedInput className="form-control"
											   mask={emailMask}
											   placeholder="_______ @ ______ . ___"
											   type="text"
											   name="informedAddress"
											   inputProps={{vdata:"email", vlength:'1,255'}}
											   id="tInformedAddress"
											   ref="tInformedAddress"
											   onBlur={() => this.validateField({
												   target: {
													   id: "tInformedAddress",
													   dataset: {vdata: "email", vlength:'1,255'},
													   value: this.state.informedAddress
												   }
											   })}
											   value={this.state.informedAddress}
											   onChange={(e) => this.onChangeInformedAddress(e)}/>
										{this.validateMessage('tInformedAddress') !== "" &&
										<UncontrolledTooltip placement="right" target="tInformedAddress" delay={0}>
											{this.validateMessage("tInformedAddress")}
										</UncontrolledTooltip>}
									</div>
								}

								{this.state.warningType === 2 &&
								<div className="col-sm-12">
									<div className={"form-group" + this.validateClass('tInformedAddress')}>
										<MaskedInput className="form-control"
											   mask={['0','(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
											   placeholder="0 (___) ___ __ __"
											   type="text"
											   name="informedAddress"
											   inputProps={{vdata:"required", vlength:'1,255'}}
											   id="tInformedAddress"
											   ref="tInformedAddress"
											   onBlur={() => this.validateField({
												   target: {
													   id: "tInformedAddress",
													   dataset: {vdata: 'required', vlength:'1,255'},
													   value: this.state.informedAddress
												   }
											   })}
											   value={this.state.informedAddress}
											   onChange={(e) => this.onChangeInformedAddress(e)}/>
										{this.validateMessage('tInformedAddress') !== "" &&
										<UncontrolledTooltip placement="right" target="tInformedAddress" delay={0}>
											{this.validateMessage("tInformedAddress")}
										</UncontrolledTooltip>}
									</div>
								</div>}
							</div>
						</div>
						<ModalFooter>
							<Button type="button"
									data-toggle="tooltip" data-placement="bottom"
									title="İptal"
									style={{background: 'rgb(158, 158, 158)', padding: '8px 40px 8px 13px'}}
									rel="tooltip" className="TekBtn vazgec"
									onClick={this.closeEditWarningModal}> İptal
							</Button>
							<Button type="button"
									data-toggle="tooltip" data-placement="bottom"
									title="Ekle"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), rgb(159, 208, 55))',
										padding: '8px 40px 8px 13px'
									}}
									rel="tooltip" className="TekBtn kaydet"
									onClick={this.updateWarning}> Onayla
							</Button>
						</ModalFooter>
					</ModalBody>
				</Modal>
			</div>
		)
	}
}

export default InboxWarning;